import React, { useContext, Fragment } from "react"

import { Slide } from "../../display_wallet.js"
import Slide_Send_Tokens from "./Slide_Send_Tokens.js"
import Slide_Send_BSV from "./Slide_Send_BSV.js"
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import { getLog } from "../../helpers/helpers.js"
import CoinHeader from "../../components/CoinHeader.js"


export default function Slide_Send(props) {
	const userContext = useContext(UserContext)
	const function_id = "Slide_Send: "
	const log = getLog(function_id)

	const coinProps = userContext.get_selected_coin_props()
	// examples: coinProps.tokenid ticker .name .logo .color
	log("coinProps.tokenid=", coinProps.tokenid)

	let slide_jsx = null
	if (coinProps.tokenid === 'bsv') {
		slide_jsx = <Slide_Send_BSV {...props} />
	}
	else {
		slide_jsx = <Slide_Send_Tokens {...props} />
	}

	return (
		<Slide num={props.num} >
			<center>
				<CoinHeader />
				<br />
				{slide_jsx}
			</center>
		</Slide>
	)

	/* // old version
		return (
			<Slide num={props.num} dontaddspacebelow style={{ paddingTop: "0px", overflowX: "hidden" }}>
				<With2Tabs
					startingtab="1"
					title_tab1="Envoyer Delphe"
					title_tab2="Envoyer BSV"
					content_tab1={jsx_slide_send_delphe}
					content_tab2={jsx_slide_send_bsv}
				/>
			</Slide>
		)
		*/
}
